import { render, staticRenderFns } from "./TargetAndRewardValues.vue?vue&type=template&id=48ae5f0c&scoped=true&"
import script from "./TargetAndRewardValues.vue?vue&type=script&lang=js&"
export * from "./TargetAndRewardValues.vue?vue&type=script&lang=js&"
import style0 from "./TargetAndRewardValues.vue?vue&type=style&index=0&id=48ae5f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ae5f0c",
  null
  
)

export default component.exports